<form [formGroup]="formImprimir" class="imprimir-container">
  <p class="dialog-title">Impresión</p>
  <hr class="dialog-divider" />

  <mat-form-field class="mat-form-field-combo">
    <mat-label>Selecciona la información a imprimir</mat-label>
    <mat-select
      formControlName="tipoImpresion"
      name="tipoImpresion"
      (valueChange)="reset()">
      <mat-option disabled="true">Seleccione una opción</mat-option>
      @for (tipo of tiposImpresion; track tipo) {
      <mat-option [value]="tipo">{{ tipo.type }}</mat-option>
      }
    </mat-select>
    @if (formImprimir.get('tipoImpresion')?.invalid &&
    formImprimir.get('tipoImpresion')?.touched) {
    <mat-error> Campo obligatorio </mat-error>
    }
  </mat-form-field>

  <div *ngIf="despachos$ | async as empresas">
    <mat-form-field
      class="mat-form-field-combo"
      *ngIf="
        formImprimir.get('tipoImpresion')?.value &&
        formImprimir.get('tipoImpresion')?.value?.id_tipo_despacho === 3
      ">
      <mat-label>Empresa</mat-label>
      <mat-select
        [(ngModel)]="empresa"
        formControlName="empresa"
        name="empresa">
        <mat-option value="" disabled="true">Seleccione una opción</mat-option>
        @for (empresa of empresas; track empresa) {
        <mat-option [value]="empresa">{{ empresa.descripcion }}</mat-option>
        }
      </mat-select>
      @if (formImprimir.get('empresa')?.invalid &&
      formImprimir.get('empresa')?.touched) {
      <mat-error> Campo obligatorio </mat-error>
      }
    </mat-form-field>
  </div>
</form>
<div class="flex-button-end" mat-dialog-actions>
  <button class="uppercase-button" mat-raised-button [mat-dialog-close]="false">
    Cancelar
  </button>
  <button
    class="uppercase-button"
    mat-flat-button
    [color]="'primary'"
    [disabled]="
      !formImprimir.get('tipoImpresion')?.value ||
      (formImprimir.get('tipoImpresion')?.value &&
        formImprimir.get('tipoImpresion')?.value.id_tipo_despacho === 3 &&
        !empresa)
    "
    [mat-dialog-close]="true"
    (click)="confirm()">
    Aceptar
  </button>
</div>
